import {
  Livewire,
  Alpine,
} from '../../vendor/livewire/livewire/dist/livewire.esm';

// Plugins
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';
import focus from '@alpinejs/focus';
import './plugins/axios';
import './plugins/gsap';
import './plugins/lodash';
import './plugins/siteimprove';
import './plugins/slide';

// Alpine Component
import './components/accordion';
import './components/audioController';
import './components/cardsAnimation';
import './components/carousel';
import './components/desktop-nav';
import './components/dialog';
import './components/entranceBlock';
import './components/footerPlaceholder';
import './components/headerNavigation';
import './components/memberMeetingSignup';
import './components/heartModule';
import './components/modal';
import './components/search-form';
import './components/self-service';
import './components/splitWord';
import './components/stepByStep';
import './components/stickyObserver';
import './components/subsidy-symbol';
import './components/swiper';
import './components/tableCellWidth';
import './components/testimonials';
import './components/video-player';
import './components/videoController';
import './util/data-layer-push';
import './store/menu';
import './store/mobile-menu';

// Polyfills
import 'focus-visible'; // :focus-visible polyfill
import 'whatwg-fetch'; // window.fetch polyfill for IE11

Alpine.plugin(collapse);
Alpine.plugin(intersect);
Alpine.plugin(focus);

Livewire.start();
